import React from 'react';
import { motion } from 'framer-motion';
import { FiCpu, FiZap } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const LLMSelector = ({ selectedModel, onModelChange }) => {
  const models = [
    {
      id: 'gpt-4',
      name: 'GPT-4',
      description: 'OpenAI GPT 4o mini - excellent for professional output.',
      icon: FiCpu,
      color: 'bg-blue-500'
    },
    {
      id: 'claude-3',
      name: 'Claude-3',
      description: 'Anthropic Claude 3.5 Sonnet -  excellent for creative output.',
      icon: FiZap,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-gray-700">
        AI Model Selection
      </label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {models.map((model) => (
          <motion.button
            key={model.id}
            type="button"
            onClick={() => onModelChange(model.id)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={`relative p-4 rounded-lg border-2 transition-all duration-200 text-left ${
              selectedModel === model.id
                ? 'border-primary-500 bg-primary-50 shadow-md'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className={`flex-shrink-0 w-8 h-8 ${model.color} rounded-lg flex items-center justify-center`}>
                <SafeIcon icon={model.icon} className="h-4 w-4 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className={`text-sm font-medium ${
                  selectedModel === model.id ? 'text-primary-900' : 'text-gray-900'
                }`}>
                  {model.name}
                </h3>
                <p className={`text-xs mt-1 ${
                  selectedModel === model.id ? 'text-primary-700' : 'text-gray-500'
                }`}>
                  {model.description}
                </p>
              </div>
            </div>
            
            {selectedModel === model.id && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute top-2 right-2 w-4 h-4 bg-primary-500 rounded-full flex items-center justify-center"
              >
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </motion.div>
            )}
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default LLMSelector;